import * as React from "react";
import { ItemPageProps } from "./debate-note-item-page";
import { QuoteModel } from "../model/autogen/QuoteModel";
import { withSnackbar } from "../components/with-snackbar";
import { withAuthContext } from "../components/with-auth-context";
import { Content } from "../components/content";
import { Card, LinearProgress} from "@material-ui/core";
import { BlockQuote } from "../components/material/block-quote";
import { QuoteRequestFactory } from "../model/autogen/QuoteController";
import { QuoteEditRoute } from "route-paths";
import { DocumentActionList } from "components/document-action-list";

export interface IQuotePageState {
    model: QuoteModel | undefined;
}


class QuoteItemPageComponent extends React.Component<ItemPageProps, IQuotePageState> {
    constructor(props: ItemPageProps) {
        super(props);
        this.state = { model: undefined };
    }

    public async componentDidMount() {
        this.loadContent();
    }

    private loadContent = async () => {
        const id = parseInt(this.props.match.params.id, 10);
        const model = await this.props.callApi((fetcher) => QuoteRequestFactory.getById(fetcher,
            id, false));
        this.setState({ model });
    }

    private onDelete = async () => {
        const {model} = this.state
        if (model && confirm("Are you sure you want to archive this content?")) {
            this.props.showSnackbarMessage("Archiving content ...");
            try {
                const result = await this.props.callApi((fetcher) => QuoteRequestFactory.delete(fetcher, model.id));
                if (result) {
                    this.props.showSnackbarMessage("Content archived");
                    this.props.history.goBack();
                }
            } catch (e) {
                this.props.showSnackbarMessage(`Failed to archive content: ${e}`);
            }
        }
    }

    public render() {
        const { model } = this.state;
        if (!model) {
            return <LinearProgress />;
        }
        return <Content>
            <h1>Transcript</h1>
            <Card>
                <Content>
                    <BlockQuote quote={model} author={model.person} />
                </Content>
            </Card>
            <DocumentActionList editRoute={QuoteEditRoute(model.id)} model={model} user={this.props.user} onDelete={this.onDelete} />
        </Content>
    }



}

export const QuoteItemPage = withSnackbar(withAuthContext(QuoteItemPageComponent) as any);



// WEBPACK FOOTER //
// ./src/pages/quote-item-page.tsx